import { render, staticRenderFns } from "./AgreementFormPage.vue?vue&type=template&id=64290cde&scoped=true&"
import script from "./AgreementFormPage.vue?vue&type=script&lang=ts&"
export * from "./AgreementFormPage.vue?vue&type=script&lang=ts&"
import style0 from "./AgreementFormPage.vue?vue&type=style&index=0&id=64290cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64290cde",
  null
  
)

export default component.exports